import React from "react";
import shareBird from "../assets/thanksbtn.png";
import shareIcon from "../assets/share.png";
import SeeMoreButton from "./SeeMoreButton";

const Share = (props) => {
  const { setIsOpen, setShareModelOpen, pauseAllMedia, onSeeMore } = props;

  const handleSeeMoreClick = () => {
    if (pauseAllMedia) {
      pauseAllMedia();
    }
    if (onSeeMore) {
      onSeeMore();
    }
  };

  return (
    <div className="share-container">
      {/* 1. Loved your JiveBird Banner */}
      <div className="jb-banner-card">
        <div className="jb-banner-title">Loved your JiveBird?</div>
        <div className="jb-banner-subtitle">Send 25 JiveBirds FREE</div>
        <SeeMoreButton onClick={handleSeeMoreClick}>
          Create my FREE JiveBird &amp; See More
        </SeeMoreButton>
        <div className="jb-banner-footer-text">
          For Christmas, New Year, Birthdays every special occassion.
        </div>
      </div>

      {/* 2. Action Buttons: Say Thanks & Share */}
      <div className="jb-actions-row">
        <button
          type="button"
          className="jb-action-btn"
          onClick={() => setIsOpen(true)}
        >
          <img src={shareBird} alt="Say Thanks" className="jb-action-icon-bird" />
          <span className="jb-action-text">Say Thanks</span>
        </button>

        <button
          type="button"
          className="jb-action-btn"
          onClick={() => setShareModelOpen(true)}
        >
          <img src={shareIcon} alt="Share" className="jb-action-icon-share" />
          <span className="jb-action-text">Share</span>
        </button>
      </div>
    </div>
  );
};

export default Share;